import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { transformNumber } from "utils/transformNumber";
import _ from 'lodash';
import styled from 'styled-components';

import TypeAheadDropdown from "../Components/TypeAheadDropdown";
import GridTextInput from "../Components/GridTextInput";
import GridPercentInput from "../Components/GridPercentInput";
import GridTextArea from "../Components/GridTextArea";
import SectionTitle from '../Components/SectionTitle';
import MultipleLenderInput from '../Components/MultipleLenderInput';
import { getConfigItemByParentId } from "store/state/configItems";
import {
  getLoanSeniorityTypes,
  getLenders,
  getDealStages,
  getDealStatuses,
  getPrepaymentTypes
} from "store/state/enumeratedTypes";
import {
  LOAN_TYPE,
  INTEREST_RATE_TYPE,
  FIXED_INDICES,
  FLOATING_INDICES,
  LENDER_TYPE,
  AMORTIZATION_TYPE,
  MEZZ_RATE,
  MEZZ_FUNDING_STRUCTURE,
  AGGREGATE_INTEREST_METHODS
} from "constants/configItemParents";
import amortizationTypes from "constants/amortizationTypes";
import { setConfigItemListState, setEnumeratedTypesListState } from "../util";
import loanTypes, { loanTypeList } from 'constants/loanTypes';
import loanStatuses from "constants/loanStatuses";
import loanSeniorityTypes from "constants/loanSeniorityTypes"
import { AddButton, CloseButton } from "components/Global/Buttons";

const FIXED = "53669856-4681-11e9-82f6-0242ac120002";
const INTERNALLY_FIXED = "2a7680cd-467f-11e9-82f6-0242ac120002";

const AGGREGATE_INTEREST = "6b1101cc-4694-11e9-82f6-0242ac120002";
const DEFINED = "998e6888-830c-11e9-a53c-0242ac120002";
const FORMULAIC = "9cdef848-830c-11e9-a53c-0242ac120002";

const FLAT_PERCENTAGE = "530f4ae6-4694-11e9-82f6-0242ac120002";

const AddLenderButton = styled(AddButton)`
  && {
    left: -13px;
  }
`;

class LoanTerms extends React.Component {
  state = {
    loanClassifications: [],
    rateTypes: [],
    loanIndicesFixed: [],
    loanIndicesFloating: [],
    amortizationTypes: [],
    mezzRates: [],
    mezzFundingStructures: [],
    aggregateInterestMethods: [],

    loanLenders: [],
    loanLenderTypes: [],
    loanTypes: [],
    loanSeniorityTypes: [],
    prepaymentTypes: [],
    amortizationRate: "",
    indexFloor: "",
    loanSpread: "",
    quoteFlatPercentageAmount: "",
    hasLeadSelected: true,
    loanProvider: [],
  };

  static getDerivedStateFromProps(props, state) {
    const { loan } = props;
    return {
      amortizationRate: loan.amortizationRate || loan.amortizationRate === 0 ? loan.amortizationRate * 100 : "",
      indexFloor: loan.indexFloor || loan.indexFloor === 0 ? loan.indexFloor * 100 : "",
      loanSpread: loan.loanSpread || loan.loanSpread === 0 ? loan.loanSpread * 100 : "",
      quoteFlatPercentageAmount: loan.quoteFlatPercentageAmount || loan.quoteFlatPercentageAmount === 0 ? loan.quoteFlatPercentageAmount * 100 : ""
    };
  }

  componentDidMount() {
    this.props.getConfigItemByParentId({ id: LOAN_TYPE });
    this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
    this.props.getConfigItemByParentId({ id: FIXED_INDICES });
    this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
    this.props.getConfigItemByParentId({ id: AMORTIZATION_TYPE });
    this.props.getConfigItemByParentId({ id: LENDER_TYPE });
    this.props.getConfigItemByParentId({ id: MEZZ_RATE });
    this.props.getConfigItemByParentId({ id: MEZZ_FUNDING_STRUCTURE });
    this.props.getConfigItemByParentId({ id: AGGREGATE_INTEREST_METHODS });

    this.props.getLoanSeniorityTypes();
    this.props.getLenders();
    this.props.getPrepaymentTypes();
  }

  componentDidUpdate = () => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(LOAN_TYPE, "loanClassifications", this);
      setConfigItemListState(INTEREST_RATE_TYPE, "rateTypes", this);
      setConfigItemListState(FIXED_INDICES, "loanIndicesFixed", this);
      setConfigItemListState(FLOATING_INDICES, "loanIndicesFloating", this);
      setConfigItemListState(LENDER_TYPE, "loanLenderTypes", this);
      setConfigItemListState(AGGREGATE_INTEREST_METHODS, "aggregateInterestMethods", this);
      setConfigItemListState(AMORTIZATION_TYPE, "amortizationTypes", this, [
        amortizationTypes.STRAIGHT_LINE_CUSTOM_AMORT
      ]);

      setConfigItemListState(MEZZ_RATE, "mezzRates", this);
      setConfigItemListState(
        MEZZ_FUNDING_STRUCTURE,
        "mezzFundingStructures",
        this
      );
    }
    if (this.props.enumeratedTypes) {
      setEnumeratedTypesListState(
        "loan_seniority_types",
        "loanSeniorityTypes",
        this, [], false, false, false
      );

      setEnumeratedTypesListState("lenders", "loanLenders", this, null, false, true, false);
      setEnumeratedTypesListState("prepayment_types", "prepaymentTypes", this, null, true, false, false);
    }
  };

  getIndexTypes() {
    if (this.props.loan && this.props.loan.rateTypeId) {
      return this.props.loan.rateTypeId === FIXED
        ? this.state.loanIndicesFixed
        : this.state.loanIndicesFloating;
    }
    return [];
  }

  filterLoanTypesByLoanSeniorityType = (loanSeniorityId) => {
    let ids = [];
    if (loanSeniorityId === loanSeniorityTypes.SENIOR) {
      ids = [4, 5, 3, 1, 6, 7, 8, 11, 2, 10];
    } else if (loanSeniorityId === loanSeniorityTypes.SUBORDINATE) {
      ids = [9, 12];
    } else if (loanSeniorityId === loanSeniorityTypes.SUPPLEMENTAL) {
      ids = [6, 7];
    }
    return _.filter(loanTypeList, (v) => _.includes(ids, v.value));
  }

  addEmptyLender = () => {

    const { loan } = this.props;
    const { loanProviders } = loan;
    let loanProvidersCopy = (loanProviders && loanProviders.length > 0) ? loanProviders : [];

    const emptyLender = { id: null, lenderAllocation: null, isLead: false, companyId: null };

    loanProvidersCopy.push(emptyLender);
    this.props.handleChange("loanProviders", { value: loanProvidersCopy });
  }

  removeLender = (index) => {
    const loanProviders = this.props.loan.loanProviders;
    loanProviders.splice(index, 1);
    this.props.handleChange("loanProviders", { value: loanProviders });
  }

  handleLoanLenderChange = (loanLender, loanLenderIndex) => {
    const { loan } = this.props;
    const { loanProviders } = loan;
    let loanProvidersCopy = (loanProviders && loanProviders.length > 0) ? loanProviders : [];
    loanProvidersCopy[loanLenderIndex] = loanLender;
    this.props.handleChange("loanProviders", { value: loanProvidersCopy });
  };

  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      selectedLoanStatusId,
      isNewLoan,
      isEditing,
      isInitialized,
      guestPermissions
    } = this.props;

    if (_.isEmpty(loan) && !isNewLoan) return null;


    if (!loan.loanProviders) {
      this.addEmptyLender();
      return null;
    }

    const isConstruction = loan.loanTypeId === loanTypes.CONSTRUCTION;
    const isValueAdd = loan.loanTypeId === loanTypes.VALUE_ADD;
    const isOther =
      loan.loanTypeId &&
      loan.loanTypeId !== loanTypes.CONSTRUCTION &&
      loan.loanTypeId !== loanTypes.VALUE_ADD;

    const filteredLoanTypes = this.filterLoanTypesByLoanSeniorityType(this.props.loan.loanSeniorityId);

    return (
      <Fragment>
        <span id="loan_terms">
          <Grid item xs={7}>
            <SectionTitle>Loan Terms</SectionTitle>
          </Grid>
          {loan.loanProviders && loan.loanProviders.map((x, i) =>
            <Grid container item={true} xs={12}>
              <MultipleLenderInput
                label={i === 0 ? "Lender(s)" : ""}
                selectName="lenderCompanyId"
                selectPlaceholder="Select a Lender"
                textName="lenderAllocation"
                textPlaceholder="Lender Allocation"
                shouldShowLeadTag={loan.loanProviders.length > 1}
                loanLenders={this.state.loanLenders}
                loanLender={loan.loanProviders[i]}
                handleLoanLenderChange={this.handleLoanLenderChange}
                shouldShowCheckboxAndAllocation={loan.loanProviders.length > 1}
                shouldShowRemoveButton={i > 0}
                removeLender={this.removeLender}
                index={i}
                hasLeadSelected={loan.loanProviders.length > 1 && loan.loanProviders.some(loanProvider => loanProvider.isLead)}
                isEditing={isEditing}
                shouldShow={i === 0 || loan.loanProviders.length > 1}
              />
            </Grid>
          )
          }

          {isEditing &&
            <Grid container item={true} xs={12}>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}>
                <AddLenderButton
                  title="ADD LENDER"
                  onClick={this.addEmptyLender}
                />
              </Grid>
            </Grid>}


          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="loanSeniorityId"
              label="Loan Seniority *"
              placeholder="Select a Seniority"
              options={this.state.loanSeniorityTypes}
              value={loan.loanSeniorityId}
              handleChange={data => handleChange("loanSeniorityId", data)}
              isEditing={isEditing}
              shouldShow={true}
            />
          </Grid>
          {(!this.props.authentication.isGuest || (this.props.authentication.isGuest && guestPermissions.pipelineAllowQuoteStatus)) &&
            <Grid container item={true} xs={12}>
              <TypeAheadDropdown
                name="loanStatusId"
                label="Loan Status"
                placeholder="Select a Status"
                options={this.props.loanStatuses}
                value={loan.loanStatusId}
                handleChange={data => handleChange("loanStatusId", data)}
                isEditing={isEditing}
                shouldShow={loan.loanStatusId !== loanStatuses.WINNING_QUOTE} />
              <GridTextInput
                name="loanStatusWinningQuote"
                label="Loan Status"
                value="Winning Quote"
                isEditing={false}
                shouldShow={loan.loanStatusId === loanStatuses.WINNING_QUOTE} />
            </Grid>}
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="loanTypeId"
              label="Loan Type"
              placeholder="Select a Type"
              options={filteredLoanTypes}
              value={loan.loanTypeId}
              handleChange={data => handleChange("loanTypeId", data)}
              isEditing={isEditing}
              shouldShow={true}
            />
          </Grid>

          <Grid container item={true} xs={12}>
            <GridTextInput
              name="amount"
              label="Loan Amount"
              mask="currencynocents"
              value={loan.amount}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="initialProceeds"
              label="Initial Proceeds"
              mask="currencynocents"
              value={loan.initialProceeds}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                (isConstruction || isValueAdd) &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="loanTermMonths"
              label="Term (Months)"
              type="number"
              value={loan.loanTermMonths}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="extensionOptions"
              label="Extension Options"
              type="number"
              value={loan.extensionOptions || ""}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="extensionTermMonths"
              label="Extension Term (Months)"
              type="number"
              value={loan.extensionTermMonths}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="rateTypeId"
              label="Rate Type"
              placeholder="Select a Rate Type"
              options={this.state.rateTypes}
              value={loan.rateTypeId}
              handleChange={data => handleChange("rateTypeId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="mezzRateTypeId"
              label="Mezz Rate"
              placeholder="Select a Mezz Rate"
              options={this.state.mezzRates}
              value={loan.mezzRateTypeId}
              handleChange={data => handleChange("mezzRateTypeId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE &&
                loan.loanSeniorityId === loanSeniorityTypes.SUBORDINATE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="indexId"
              label="Index"
              placeholder="Select an Index"
              options={this.getIndexTypes()}
              value={loan.indexId}
              handleChange={data => handleChange("indexId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridPercentInput
              name="loanSpread"
              label={loan.indexId === INTERNALLY_FIXED ? 'Rate' : "Spread"}
              value={this.state.loanSpread}
              onBlur={item => {
                handleTextChange({
                  target: {
                    name: "loanSpread",
                    value:
                      item.target.value === ""
                        ? ""
                        : transformNumber(item.target.value) / 100
                  }
                });
              }}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridPercentInput
              name="indexFloor"
              label="Index Floor"
              value={this.state.indexFloor}
              onBlur={item => {
                handleTextChange({
                  target: {
                    name: "indexFloor",
                    value:
                      item.target.value === ""
                        ? ""
                        : transformNumber(item.target.value) / 100
                  }
                });
              }}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextArea
              name="additionalInterest"
              label="Additional Interest"
              value={loan.additionalInterest}
              multiline={true}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                !isOther &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="amortizationTypeId"
              label="Amortization"
              placeholder="Select an Amortization"
              options={this.state.amortizationTypes}
              value={loan.amortizationTypeId}
              handleChange={data => handleChange("amortizationTypeId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="amortizationTerm"
              label="Amortization Term (Months)"
              value={loan.amortizationTerm}
              type="number"
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE &&
                loan.amortizationTypeId !== amortizationTypes.INTEREST_ONLY
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="ioPeriod"
              label="I/O Periods"
              value={loan.ioPeriod}
              type="number"
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE &&
                loan.amortizationTypeId !== amortizationTypes.INTEREST_ONLY
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridPercentInput
              name="amortizationRate"
              label="Amortization Rate"
              value={this.state.amortizationRate}
              onBlur={item => {
                handleTextChange({
                  target: {
                    name: "amortizationRate",
                    value:
                      item.target.value === ""
                        ? ""
                        : transformNumber(item.target.value) / 100
                  }
                });
              }}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE &&
                loan.amortizationTypeId !== amortizationTypes.STRAIGHT_LINE &&
                loan.amortizationTypeId !==
                amortizationTypes.STRAIGHT_LINE_CUSTOM_AMORT &&
                loan.amortizationTypeId !== amortizationTypes.AGENCY_FLOATER &&
                loan.amortizationTypeId !== amortizationTypes.INTEREST_ONLY
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="prepaymentTypeId"
              label="Prepayment"
              id="dropdownForPrepaymentType"
              placeholder="Select a Prepayment"
              options={this.state.prepaymentTypes}
              value={loan.prepaymentTypeId}
              handleChange={data => handleChange("prepaymentTypeId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
            />
          </Grid>

          {/* AGGREGATE_INTEREST */}
          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="quoteAggregateInterestMethodId"
              label="Method"
              id="dropdownForAggregateInterestMethod"
              placeholder="Select a Method"
              options={this.state.aggregateInterestMethods}
              value={loan.quoteAggregateInterestMethodId}
              handleChange={data => handleChange("quoteAggregateInterestMethodId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                loan.prepaymentTypeId != null &&
                loan.prepaymentTypeId === AGGREGATE_INTEREST
              }
            />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="quoteAggregateInterestDefinedAmt"
              label="Amount"
              mask="currencynocents"
              value={loan.quoteAggregateInterestDefinedAmt}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                loan.prepaymentTypeId != null &&
                loan.prepaymentTypeId === AGGREGATE_INTEREST &&
                loan.quoteAggregateInterestMethodId !== null &&
                loan.quoteAggregateInterestMethodId === DEFINED} />
          </Grid>
          <Grid container item={true} xs={12}>
            <GridTextInput
              name="quoteAggregateInterestMonthsOfInterest"
              mask="wholeNumberMask"
              label="Months of Interest"
              type="number"
              value={loan.quoteAggregateInterestMonthsOfInterest}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                loan.prepaymentTypeId != null &&
                loan.prepaymentTypeId === AGGREGATE_INTEREST &&
                loan.quoteAggregateInterestMethodId !== null &&
                loan.quoteAggregateInterestMethodId === FORMULAIC} />
          </Grid>


          <Grid container item={true} xs={12}>
            <GridPercentInput
              name="quoteFlatPercentageAmount"
              label="Flat %"
              value={this.state.quoteFlatPercentageAmount}
              onBlur={item => {
                handleTextChange({
                  target: {
                    name: "quoteFlatPercentageAmount",
                    value:
                      item.target.value === ""
                        ? ""
                        : transformNumber(item.target.value) / 100
                  }
                });
              }}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                loan.prepaymentTypeId != null &&
                loan.prepaymentTypeId === FLAT_PERCENTAGE
              }
            />
          </Grid>



          <Grid container item={true} xs={12}>
            <TypeAheadDropdown
              name="mezzFundingStructureId"
              label="Mezz Funding Structure"
              placeholder="Select a Mezz Funding Structure"
              options={this.state.mezzFundingStructures}
              value={loan.mezzFundingStructureId}
              handleChange={data => handleChange("mezzFundingStructureId", data)}
              isEditing={isEditing}
              shouldShow={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE &&
                loan.loanSeniorityId === loanSeniorityTypes.SUBORDINATE
              }
            />
          </Grid>
        </span>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems, enumeratedTypes, authentication } = state;
  return {
    authentication,
    loading,
    configItems,
    enumeratedTypes: enumeratedTypes.enumeratedTypes
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId,
      getLoanSeniorityTypes,
      getLenders,
      getDealStages,
      getDealStatuses,
      getPrepaymentTypes
    }
  ),
)(LoanTerms);
